import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ChakraProvider } from '@chakra-ui/react'
import { HelmetProvider } from 'react-helmet-async'
import App from './App'
import theme from './theme.js'
import '@fontsource/rozha-one/400.css'
import '@fontsource/rozha-one/devanagari-400.css'
import './index.css'
import './registerServiceWorker'
import ErrorBoundary from './components/ErrorBoundary'

const root = createRoot(document.getElementById('root'))

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <HelmetProvider>
          <ChakraProvider theme={theme}>
            <App />
          </ChakraProvider>
        </HelmetProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
)
